import { useEffect } from 'react';

export default function Catalogue() {
  useEffect(() => {
    // Redirect directly to the catalogue (same behavior as Resources page button)
    window.location.href = 'https://kilobrochure-gyyvv4cq.manus.space/brochure.html';
  }, []);

  return (
    <div className="w-full h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to Product Catalogue...</p>
      </div>
    </div>
  );
}
